import axios from "axios";

import { getApiBaseUrl } from "../constants/ApiConstant";
import { AUTH_TOKEN } from "redux-thunk/constants/Auth";
import { signOut } from "redux-thunk/actions/Auth";
import { store } from "redux-thunk/store";

const service = axios.create({
  timeout: 1 * 60 * 60 * 1000,
});

const requestHandler = (request) => {
  // Set on every request so first call uses URLs after setBaseUrl finishes
  request.baseURL = getApiBaseUrl();

  const token = localStorage.getItem(AUTH_TOKEN);
  const locale = localStorage.getItem("locale");
  if (token != null) {
    request.headers["x-access-token"] = token;
  }
  request.headers["locale"] = locale;
  request.headers["Access-Control-Allow-Origin"] = "*";
  request.headers["Accept"] = "application/json";

  return request;
};

const responseHandler = (response) => {
  const { dispatch } = store;
  if (response.status == 401 || response.status == 403) {
    dispatch(signOut());
  }
  return response;
};

const errorHandler = (error) => {
  console.log("Error ------- ", error?.response);
  if (error?.response?.status == 401 || error?.response?.status == 403) {
    responseHandler(error?.response);
  }
  return Promise.reject(error);
};

service.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error),
);
service.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error),
);

export default service;
